import StoreOnboardingProgressionsService from "@/api/services/storeOnboardingProgressions";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  index: [],
  totalCount: null,
  totalPages: null,
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    getIndex(state) {
      return state.index;
    },
    getTotalPages(state) {
      return state.totalPages;
    },

    getTotalCount(state) {
      return state.totalCount;
    },
    getProgressions: () => () => {
      return ["late", "on_time", "ahead_of_schedule"];
    },
    getAllowedStatusPhases: () => (status) => {
      if (!status) return [];

      switch (status.toLowerCase()) {
        case "setup":
          return ["waiting_for_information_completion", "pending_validation"];
        case "formation":
          return ["training_date_to_fix", "waiting_for_training", "waiting_for_first_sale"];
        case "rampup":
          return ["first_rampup", "second_rampup", "third_rampup"];
        default:
          return [];
      }
    },
  },
  mutations: {
    setIndex(state, data) {
      state.index = data.storeOnboardingProgressions;
    },
    setPagination(state, data) {
      state.totalCount = data.page.totalCount;
      state.totalPages = data.page.totalPages;
    },
  },
  actions: {
    async fetchIndex(
      { commit },
      { page, status, keywords, category, statusPhase, progression, organization, order } = {},
    ) {
      const response = await StoreOnboardingProgressionsService.fetchIndex({
        page,
        status,
        keywords,
        category,
        statusPhase,
        progression,
        organization,
        order,
      });
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("setIndex", data);
      commit("setPagination", data);

      return response;
    },
  },
};
